import { buildContentUrl } from 'omni-package-react-cms';

export default function getSitecorePath(path: string, hasChildren: boolean, mockPath: string) {
  return (
    (process.env.REACT_APP_MOCK_SITECORE_PATH === 'true') ?
      mockPath :
      buildContentUrl(path, hasChildren)
  );
}
